import { Button, Grid, TextField } from '@mui/material';
import * as React from 'react';
import { useHistory } from "react-router-dom";
import { BasePageStyles } from '../../hooks/styles';
import { IMAGES_URL } from '../../constants/Images';
import Api from '../../redux/lib/api';
import { LOGIN } from '../../redux/constants/api.url';
import { CartProvider, useCart } from "react-use-cart";
import Add from '@mui/icons-material/Add';
import { PRODUCTS } from '../../constants/Products';
import { FormatCurrency } from '../../hooks/functions/FormatCurrency';
import DeleteIcon from '@mui/icons-material/Delete';
import { Interweave, Node } from 'interweave';

interface CartProps {}

export const CartComponent: React.FC<CartProps> = (props) => {
	const classes = BasePageStyles();
	const history = useHistory(); 

	const routeChange = (path: string) =>{ 
	 	history.push(path);
	 }

 const {
    isEmpty,
    totalUniqueItems,
    totalItems,
    items,
    updateItemQuantity,
    removeItem,
    cartTotal
  } = useCart();

  const products = PRODUCTS;

	const onProceedToCheckout = () => {
		routeChange('/payment')
	}

	const onBackToBrowse = () => {
		routeChange('/browse')
	}

	return (
		<Grid container item textAlign={'left'} xs={12} md={6}>
			<Grid item xs={12}>
				 
			      <h1 style={{marginBottom: 40}}>Shopping Cart</h1>

			      <div style={{
			      	marginTop: 10,
			      	marginBottom: 10,
			      	paddingBottom: 20,
			      	borderBottom: '1px solid #ccc'
		      	}}>
				      <ul style={{margin: 0, padding: 0}}>
				        {items.map((item) => (
				          <li key={item.id} style={{
				          		    display: 'flex',
												 flexDirection: 'row',
												 borderTop: '1px solid #ccc',
												 marginTop: 20,
												paddingTop: 20
				          }}>

				          	{/* left aligned contents */}
				          	<div style={{
				          		display: 'flex',
				          		justifyContent: 'left',
				          		flexDirection: 'row',
				          		width: '90%',
				          	}}>

				          		<img src={item.thumbnail} style={{maxWidth: 200}} />

				          		<div style={{
					          		display: 'flex',
					          		justifyContent: 'left',
					          		flexDirection: 'column'
					          	}}>
					          		<div style={{
					          			fontWeight: 800,
					          			marginBottom: 12
				          			}}>
				          				{item.name} {Boolean(item?.isPreorder) && '(pre-order)'}
			          				</div>

			          				<div style={{
					          			fontSize: 11,
					          			marginRight: 20,
					          			marginBottom: 12
				          			}}>
				          				<Interweave content={item?.description || ''} />
			          				</div>

			          				<div style={{flexDirection: 'row',
					          			display: 'flex'}}
				          			>
				          				<div style={{
						          			marginRight: 10,
						          			marginBottom: 12,
						          			border: '2px solid #ccc',
						          			borderRadius: 15,
						          			padding: '1px 11px',
						          			width: 110,

					          			}}>

					          				{/* item qty "pill" */}
					          				<div style={{
								          		display: 'flex',
								          		flexDirection: 'row',
								          		
								          	}}>

								          		<div style={{
								          			justifySelf: 'left',
								          			paddingRight: 18,
								          			fontWeight: 800
							          			}}>
								          				<div
											              onClick={() => updateItemQuantity(item.id, (item.quantity ?? 0) - 1)}
											              style={{cursor: 'pointer'}}
											            >
											              {
											              	item.quantity === 1 ? <DeleteIcon style={{
											              		maxHeight: 16,
											              		marginTop: 3,
											              		marginLeft: -4
											              	}} /> : '-'
										              	}
											            </div>
									          		</div>
									          		<div style={{
									          			justifySelf: 'center',
									          			width: 40,
									          			fontWeight: 800,
									          			textAlign: 'center'
								          			}}>
								          				{item.quantity}
									          		</div>
									          		<div style={{
									          			justifySelf: 'right',
									          			paddingLeft: 18,
									          			fontWeight: 800
								          			}}>
								          				<div
											              onClick={() => updateItemQuantity(item.id, (item.quantity ?? 0) + 1)}
											              style={{cursor: 'pointer'}}
											           	>
											              +
											            </div>
									          		</div>
								          	</div>
			          					</div> {/* end "pill" */}

			          					<div>
						          			<a onClick={() => removeItem(item.id)} style={{cursor: 'pointer', textDecoration: 'underline', marginTop: 4, display: 'flex'}}>
						          				Delete
					          				</a>
						          		</div>
		          					</div>		          				
				          		</div>
				          	</div>

				          {/* right aligned contents */}
				          <div style={{
				          		display: 'flex',
				          		justifyContent: 'right',
				          		flexDirection: 'column',
				          		width: '10%',
				          		fontWeight: 800
				          	}}>

				          		<span style={{
				          			fontWeight: 'normal',
				          			fontSize: 13
				          		}}>
				          			{FormatCurrency(item.price as number)}&nbsp;ea.
			          			</span>
			          			<span>
					          		{FormatCurrency((item.price as number) * (item.quantity || 0))}
					          		{
					          			Boolean(item?.isPreorder) && ' (charged when order ships)'
					          		}
				          		</span>

				          	</div>

				          </li>
				        ))}
				      </ul>
			      </div>
			      <div style={{marginTop: 20, width: '100%', justifyContent: 'right', display: 'flex', flexDirection: 'column'}}>
			      	<div style={{
			      		justifyContent: 'right', display: 'flex'
		      		}}>
   							<h3>Subtotal: {FormatCurrency (cartTotal)}</h3>
 							</div>
 							<div style={{
			      		justifyContent: 'right', display: 'flex'
		      		}}>
	   						<h5 style={{
	   							color: '#ef5858',
	   							marginTop: -20
	 							}}>Tax is calculated after you proceed to checkout</h5>
 							</div>
   					</div>
   					<div style={{marginTop: 20, width: '100%', justifyContent: 'right', display: 'flex'}}>
   					<Button onClick={onBackToBrowse} variant="contained" size='large' style={{marginRight: 30}}>
								Back to Shopping
							</Button>
   						<Button onClick={onProceedToCheckout} disabled={isEmpty} variant="contained" size='large'>
								Proceed to Checkout
							</Button>
   					</div>


			</Grid>
		</Grid>
	)
}
